'use client';

import { Suspense, useState, useCallback, useMemo } from 'react';
import { PlannerListTable } from '@/widgets/planner/planner-list-table';
import { AddPlannerModal } from '@/widgets/planner/add-planner-modal';
import { Box, IconButton, Tooltip, useMediaQuery } from '@mui/material';
import { AddIcon } from '@/shared/ui/display/EmojiIcon';
import { TabPageComponent } from '@/entities/tab/model/tab.types';
import { TabContext } from '@/entities/tab/model/tab.types';
import { TabToolbar } from '@/widgets/tab/tab-toolbar';
import { MobilePageHeader } from '@/shared/ui/mobile/MobilePageHeader';
import { useSWRConfig } from 'swr';
import type { PlannerView } from '@/entities/planner';

export const PlannerListPage: TabPageComponent = function PlannerListPage(props: TabContext) {
  const params = props.params ?? {};
  const size = (params as { size?: number }).size ?? 20;
  const isMobile = useMediaQuery('(max-width:600px)');
  const [addModalOpen, setAddModalOpen] = useState(false);
  const { mutate } = useSWRConfig();

  const handleAddSuccess = useCallback(
    (_planner: PlannerView) => {
      mutate((key: unknown) => Array.isArray(key) && key[0] === 'planners-search');
    },
    [mutate]
  );

  const toolbarConfig = useMemo(
    () => ({
      right: [
        <Tooltip key="add" title="플래너 추가">
          <IconButton size="small" aria-label="플래너 추가" onClick={() => setAddModalOpen(true)}>
            <AddIcon />
          </IconButton>
        </Tooltip>,
      ],
    }),
    []
  );

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <TabToolbar tabId={props.tabId || ''} config={isMobile ? null : toolbarConfig} />
      {isMobile && (
        <MobilePageHeader
          title="플래너 목록"
          rightActions={
            <Tooltip title="플래너 추가">
              <IconButton
                size="small"
                aria-label="플래너 추가"
                onClick={() => setAddModalOpen(true)}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
          }
        />
      )}
      <Box sx={{ flex: 1, overflow: 'auto', pb: isMobile ? 0 : 0 }}>
        <Suspense fallback={null}>
          <PlannerListTable pageSize={size} tabContext={props} />
        </Suspense>
      </Box>
      <AddPlannerModal
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onSuccess={handleAddSuccess}
      />
    </Box>
  );
};

export default PlannerListPage;
